import {Permission} from "@/models/Permission";
import {Role} from "@/models/Role";
import {User} from "@/models/User";
const permissions:Permission[]=[];
const users:User[]=[];
const roles:Role[]=[];
const user = new User();
const state = {
  user,
  users,
  permissions,
  roles,
};
export default state;
export type State = typeof state
